var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-xs-12"},[_c('button',{staticClass:"btn-blue-light pb-3",on:{"click":_vm.getData}},[_c('i',{staticClass:"fas fa-headset f20 mt-1",staticStyle:{"float":"left"}}),_vm._v("\n      ENTREVISTAS\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }